import React from "react";
import WeatherIcon from "./WeatherIcon";

export default function WeatherForecastDay(props) {
function day() {
  let date = new Date(props.data.time * 1000);
  let days = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
  ];
  let day = date.getDay();

  return days[day];
}

function maxTemperature() {
  let temperature = Math.round(props.data.temperature.maximum);
  return `${temperature}º`;
}

function minTemperature() {
  let temperature = Math.round(props.data.temperature.minimum);
  return `${temperature}º`;
}

  return (
    <div>
      <div className="WeatherForecast-day">{day()}</div>
      <WeatherIcon
        code={props.data.condition.icon}
        color={"rgb(135, 135, 135)"}
        size={36}
        className="WeatherForecast-icon"
      />
      <div className="WeatherForecast-temperatures">
        <span className="WeatherForecast-temperature-max">
          {maxTemperature()}
        </span>
        <span className="WeatherForecast-temperature-min">
          {minTemperature()}
        </span>
      </div>
    </div>
  );
}
